import { getContent } from '@/lib/content';
import { logger } from '@/lib/logger';
import { IDENTITY_DOCUMENT_NUMBER } from '@/components/Form/graphql/constants';

export type IdentityDocumentValidationErrorCode =
  | 'INVALID_NATIONAL_ID'
  | 'INVALID_PASSPORT';

type IdentityDocumentValidationErrorPayload = {
  field: string;
  payload: {
    displayError: boolean;
    error: string;
    isValid: boolean;
  };
};

const getWorldReadyIdentityDocumentErrorPayload = (
  code: IdentityDocumentValidationErrorCode,
): IdentityDocumentValidationErrorPayload => {
  const key =
    code === 'INVALID_NATIONAL_ID' ? 'invalidNationalID' : 'invalidPassport';

  logger.info(`IL_AML_${code}`);

  return {
    field: IDENTITY_DOCUMENT_NUMBER,
    payload: {
      displayError: true,
      error: getContent(`fieldErrors.identityDocumentNumber.${key}`),
      isValid: false,
    },
  };
};

export { getWorldReadyIdentityDocumentErrorPayload };
